import {
    ChangeDetectionStrategy,
    Component,
    input,
    output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Side-panel page header — 72px bar with H6 title and dismiss control
 * (Figma Create Order Form page header).
 *
 * @example
 * <lib-anc-page-header
 *   [title]="'Add New Product'"
 *   (closeClick)="navigateBack()"
 * />
 */
@Component({
    selector: 'lib-anc-page-header',
    imports: [CommonModule, TranslateModule],
    templateUrl: './anc-page-header.component.html',
    styleUrls: ['./anc-page-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncPageHeaderComponent {
    /** Page title (run through the translate pipe). */
    title = input<string>('');

    /** Whether to render the dismiss control. */
    showClose = input<boolean>(true);

    /** Render the bottom divider below the title row. */
    bordered = input<boolean>(true);

    /** When false, omits the bottom border (e.g. when tabs sit directly below the title). */
    titleBordered = input<boolean>(true);

    /** Emitted when the user clicks the close button. */
    readonly closeClick = output<void>();
}
